import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import prepareGradeListFromCategoryPath from '@/Module/Grade/Helper/prepareGradeListFromCategoryPath';
import type { IGrade } from '@/Module/Grade/Model/DataModel';
import { getCategoryCategoryListAction } from '@/Module/Grade/Store/Action/getCategoryCategoryListAction';
import { gradeAdapter } from '@/Module/Grade/Store/Adapter';

const GradeSlice = createSlice({
  name: 'grade',
  initialState: gradeAdapter.getInitialState({
    isLoading: false,
    selectedGradeId: null as IGrade['id'] | null,
    selectedGradeSeoUrl: '' as string,
  }),
  reducers: {
    setSelectedGradeId: (state, { payload }: PayloadAction<IGrade['id'] | null>) => {
      state.selectedGradeId = payload;
    },
    setSelectedGradeSeoUrl: (state, { payload }: PayloadAction<IGrade['seoUrlSlug'] | ''>) => {
      state.selectedGradeSeoUrl = payload;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getCategoryCategoryListAction.pending, state => {
        state.isLoading = true;
      })
      .addCase(getCategoryCategoryListAction.rejected, state => {
        state.isLoading = false;
      })
      .addCase(getCategoryCategoryListAction.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        gradeAdapter.setAll(state, prepareGradeListFromCategoryPath(payload));
      });
  },
});

export const { setSelectedGradeId: gradeSetSelectedGradeId, setSelectedGradeSeoUrl: gradeSetSelectedGradeSeoUrl } =
  GradeSlice.actions;

export default GradeSlice;
